import { BffOverview } from "vmd-types";

import { STRAPI_URL } from "../env";
import { appQueryClient, fetchWithCache } from "./query-cache";

export async function fetchOverview(): Promise<BffOverview | undefined> {
  return fetchWithCache({
    queryKey: ["overview"],
    staleTime: 5 * 60 * 1000,
    fallback: appQueryClient.getQueryData<BffOverview>(["overview"]),
    queryFn: async () => {
      const response = await fetch(`${STRAPI_URL}/bff-overview`, {
        credentials: "include",
      });

      if (response.status >= 400) {
        throw new Error(`Fetch failed with status ${response.status}.`);
      }

      return (await response.json()) as BffOverview;
    },
  });
}
